import * as Preact from "preact"

import * as PlotSteps from "@fae/source/data/plot/steps.js"
import * as PlotConditions from "@fae/source/data/plot/conditions.js"
import * as PlotScripts from "@fae/source/data/plot/scripts.js"

import Step from "@fae/source/models/Step.js"
import Audiomix from "@fae/source/engine/Audiomix.js"

import Unit from "@fae/source/models/Unit.js"
import keywords from "@fae/source/data/games/ember/keywords.js"
import {Power, Element, Keyword, BasicDescription} from "@fae/source/data/games/ember/views/Description.jsx"

const units = {}
export default units

units["school/teacher"] = {
    "name": "Teach",
    "isRecruited": true,
    "affiliation": "good",

    "jobName": "Teacher",

    "canAttackAllies": true,
    "skillKeys": [
        "heal"
    ],

    "items": {
        "sword": {
            "title": "Schooling Sword",
            "iconKey": "relic-blade",
            "description": ({stage, unit, item}) => {
                return <span>Attack for <Power>{Unit.power({stage, unit, item})}</Power> <Element>{item.element}</Element> Damage.<br/>Can not drop target below 1 health.</span>
            },

            "element": "fire",
            "attacktype": "steel",
            "attackrange": 1,
            "power": 60,
            "properties": ["non-fatal"],
            "skillKeys": ["attack"],
            "weaponImageKey": "sword",
        },
        // "shield": {
        //     "title": "Shield",
        //     "iconKey": "armor-upgrade",
        //     "description": ({stage, unit, item}) => {
        //         return <span>Defend for <Power>{Unit.power({stage, unit, item})}</Power>.</span>
        //     },
        //     "isSmall": true,
        //     "keyword": keywords["defend"],
        //
        //     "attackrange": 1, //{"min": 0, "max": 1},
        //     "power": 40,
        //     "skillKeys": ["defend"],
        //     "weaponImageKey": "red-shield",
        // }
    },

    // "scripts": {
    //     "death": [
    //         PlotSteps.PlayStinger("Unit:Death:Knell"),
    //         "TEACHER: ...",
    //     ]
    // },
    "image": require("@fae/source/assets/images/teach-tactics/mapsprite-teacher.png"),

    "level": 20,
    "maxhealth": 70,
    "power": 0,
    "defense": 10,
    "resistance": 10,
    "moverange": 3,
}

units["school/nerd"] = {
    "name": "Nerd",
    "jobName": "Student",
    "isRecruited": true,
    "affiliation": "good",

    "canAttackAllies": true,
    "skillKeys": ["pull"],

    "items": {
        "staff": {
            "title": "Secondhand Staff",
            "iconKey": "wizard-staff",
            "description": BasicDescription,
            "element": "fire",
            "attacktype": "magic",
            "attackrange": 2,
            // "power": 20,
            "skillKeys": ["attack"],
            "weaponImageKey": "red-staff"
        }
    },

    "scripts": {
        "death": [
            PlotSteps.PlayStinger("Unit:Death:Knell"),
            "NERD: Noo, please!",
        ]
    },

    "portraits": {
        "neutral": require("@fae/source/assets/images/teach-tactics/bargainbinbrigade-nerd.png"),
    },
    "image": require("@fae/source/assets/images/teach-tactics/mapsprite-nerd.png"),

    "levelingCriteria": ["attacking"], // , "dying"], // "killing"
    "levelingCriteriaDescription": "Deal damage to earn XP",
    "levelups": {
        "2": [
            {"key": "maxhealth", "value": 10},
            {"key": "power", "value": 10},
            {"key": "maxexperience", "value": 20},
            // {"key": "skill", "value": "pull"},
        ],
        "3": [
            {"key": "maxhealth", "value": 10},
            {"key": "power", "value": 10},
            {"key": "maxexperience", "value": 40},
        ],
        "4": [
            {"key": "maxhealth", "value": 10},
            {"key": "power", "value": 10},
            {"key": "maxexperience", "value": 80},
            // {"key": "skill", "value": "swap"},
        ],
        "5": [
            {"key": "maxhealth", "value": 10},
            {"key": "power", "value": 10},
            {"key": "maxexperience", "value": 160},
        ],
    },
    "levelupPerks": [
        {"key": "nerd3", "title": "Upcasting", "description": "Always attack twice.", "property": "always attacks twice"},
        {"key": "nerd4", "title": "Cantrip", "description": "Always attack first.", "property": "always attacks first"},
        {"key": "nerd6", "title": "Dueling", "description": "Attack at both short and long range.", "trueattackrange": {"min": 1, "max": 2, "orthogonal": true, "diagonal": true}},
        {"key": "nerd5", "title": "Sorcery", "description": "2x every 4th attack.", "passiveKey": "critical"},
        {"key": "nerd1", "title": "Extra Health", "description": "+1 to max health", "maxhealth": 10},
        {"key": "nerd2", "title": "Extra Power", "description": "+1 to all attacks.", "power": 10},
        // {"key": "nerd6", "title": "Pullback", "description": "Pull you and an ally back 1 tile.", "skillKey": "pull"},
        // {
        //     "title": "Snipe",
        //     "description": "Usable Only Once: Attack for 2 fire damage in a straight line.",
        //     "items": {
        //         "snipe": {
        //             //
        //         }
        //     }
        // },
        // ???
    ],

    "level": 1,
    // "experience": 5,
    "maxexperience": 10,

    "maxhealth": 30,
    "power": 20,

    // "defense": 10,
    // "resistance": 15,

    "moverange": 2,
}

units["school/punk"] = {
    "name": "Punk",
    "jobName": "Student",
    // "isRecruited": true,
    "affiliation": "good",

    "scripts": {
        "death": [
            PlotSteps.PlayStinger("Unit:Death:Knell"),
            "PUNK: Damn it.",
        ]
    },

    "canAttackAllies": true,
    "items": {
        "axe": {
            "title": "Axe",
            "iconKey": "battered-axe",
            "description": ({stage, unit, item}) => <span>Attack for <Power>{Unit.power({stage, unit, item})}</Power> <Element>{item.element}</Element> Damage.<br/>And then Push 1 Tile.</span>,
            "element": "earth",
            "attacktype": "steel",
            "attackrange": 1,
            // "power": 20,
            "skillKeys": ["attack"],
            "properties": ["forceful"],
            "weaponImageKey": "axe",
        }
    },

    "portraits": {
        "neutral": require("@fae/source/assets/images/teach-tactics/bargainbinbrigade-punk.png"),
    },
    "image": require("@fae/source/assets/images/teach-tactics/mapsprite-punk.png"),

    "levelingCriteria": ["tanking"], // , "dying"], // "attacking"
    "levelingCriteriaDescription": "Tank damage to earn XP",
    "levelups": {
        // "2": [
        //     {"key": "maxhealth", "value": 10},
        //     {"key": "power", "value": 10},
        //     {"key": "maxexperience", "value": 10},
        //     {"key": "skill", "value": "push"},
        // ],
        "3": [
            {"key": "maxhealth", "value": 10},
            {"key": "power", "value": 10},
            {"key": "maxexperience", "value": 10},
            // {"key": "skill", "value": "charge"},
        ],
        "4": [
            {"key": "maxhealth", "value": 10},
            {"key": "power", "value": 10},
            {"key": "maxexperience", "value": 10},
            // {"key": "skill", "value": "rally"},
        ],
        "5": [
            {"key": "maxhealth", "value": 10},
            {"key": "power", "value": 10},
            {"key": "maxexperience", "value": 10},
        ],
    },
    "levelupPerks": [
        {"key": "punk2", "title": "Poise", "description": "+1 to defense, reducing physical damage by 1.", "defense": 10},
        {"key": "punk7", "title": "Nimble", "description": "Dodge every 3rd attack.", "passiveKey": "nimble"},
        {"key": "punk5", "title": "Last Stand", "description": "When you get knocked down, survive 1 more turn.", "property": "slow-death"},
        {"key": "punk4", "title": "Riposte", "description": "2x damage to counterattacks.", "property": "counter"},
        {"key": "punk1", "title": "Extra Health", "description": "+1 to max health.", "maxhealth": 10},
        {"key": "punk3", "title": "Extra Speed", "description": "+1 to movement, from 2 tiles to 3 tiles.", "moverange": 1},
        // {"key": "punk6", "title": "Tough", "description": "+4 temporary block at the start of each turn.", "skillKey": "armor-every-turn"},
        // {"key": "punk8", "title": "???", "description": "TBD"},
    ],

    "level": 2,
    "maxexperience": 10,
    "maxhealth": 60,
    "power": 20,

    // "defense": 15,
    // "resistance": 10,

    "moverange": 2,
}

units["school/goth"] = {
    "name": "Goth",
    "jobName": "Student",
    // "isRecruited": true,
    "affiliation": "good",

    "canAttackAllies": true,
    // "skillKeys": [
    //     "heal"
    // ],

    "items": {
        "staff": {
            "title": "Prototype Witchcraft",
            "iconKey": "wizard-staff",
            "description": ({stage, unit, item}) => <span>Attack for <Power>{Unit.power({stage, unit, item})}</Power> <Element>{item.element}</Element> Damage.<br/>And then Restore <Power>{Unit.power({stage, unit, item})}</Power> Health.</span>,
            "element": "water",
            "attacktype": "magic",
            "attackrange": 1,
            // "power": 10,
            "properties": ["attack-then-heal"],
            "skillKeys": ["attack"],
            "weaponImageKey": "blue-staff",
        }
    },

    "scripts": {
        "death": [
            PlotSteps.PlayStinger("Unit:Death:Knell"),
            "GOTH: Ooh, you'll regret that~",
        ]
    },

    "portraits": {
        "neutral": require("@fae/source/assets/images/teach-tactics/bargainbinbrigade-goth.png"),
    },
    "image": require("@fae/source/assets/images/teach-tactics/mapsprite-goth.png"),

    "levelingCriteria": ["healing"], // , "dying"], // "attacking"
    "levelingCriteriaDescription": "Restore health to earn XP",
    "levelups": {
        // "2": [
        //     {"key": "maxhealth", "value": 10},
        //     {"key": "power", "value": 10},
        //     {"key": "maxexperience", "value": 10},
        // ],
        // "3": [
        //     {"key": "maxhealth", "value": 10},
        //     {"key": "power", "value": 10},
        //     {"key": "maxexperience", "value": 10},
        // ],
        "4": [
            {"key": "maxhealth", "value": 10},
            {"key": "power", "value": 10},
            {"key": "maxexperience", "value": 10},
            // {"key": "skill", "value": "suplex"},
        ],
        "5": [
            {"key": "maxhealth", "value": 10},
            {"key": "power", "value": 10},
            {"key": "maxexperience", "value": 10},
        ],
    },
    "levelupPerks": [
        {"key": "goth4", "title": "Dark Arts", "description": "Healing hurts enemies.", "property": "harm-rather-than-heal"},
        {"key": "goth5", "title": "Chronomancy", "description": "Healing repeats at the start of each turn.", "property": "inflict-regenerate"},
        {"key": "goth6", "title": "Alchemy", "description": "Healing to full health also refreshes their actions.", "property": "heal-then-refresh"},
        {"key": "goth3", "title": "Biology", "description": "2x all healing.", "property": "stronger-healing"},
        {"key": "goth2", "title": "Resistance", "description": "+1 to resistance, reducing magical damage by 1.", "resistance": 10},
        {"key": "goth1", "title": "Extra Health", "description": "+1 to max health.", "maxhealth": 10},

        // {"key": "goth7", "title": "Spread", "description": "Healing hits surrounding tiles.", "property": "aoe"},
        // {"title": "Nuke", "description": "Usable Only Once: Attack for 4 water damage.", "passiveKey": ""},
    ],

    "level": 2,
    "maxexperience": 10,

    "maxhealth": 40,
    "power": 20,

    // "defense": 10,
    // "resistance": 15,

    "moverange": 2,
}

// Standard Units //

units["school/dagger"] = {
    "jobKey": "school/dagger",
    "jobName": "Thief",
    "maxhealth": 20,
    "moverange": 2,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "items": [{
        "title": "Daggers",
        "iconKey": "assassin-pocket",
        "description": BasicDescription,
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 2,
        "skillKeys": ["attack"],
        "weaponImageKey": "daggers",
    }],
}

units["school/bow"] = {
    "jobKey": "school/bow",
    "jobName": "Archer",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "items": [{
        "title": "Bow",
        "iconKey": "high-shot",
        "description": BasicDescription,
        "element": "water",
        "attacktype": "steel",
        "attackrange": 2,
        "skillKeys": ["attack"],
        "weaponImageKey": "bow",
    }],
}

units["school/gun"] = {
    "jobKey": "school/gun",
    "jobName": "Gunman",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "items": [{
        "title": "Gun",
        "iconKey": "blunderboss",
        "description": BasicDescription,
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 2,
        "skillKeys": ["attack"],
        "weaponImageKey": "gun",
    }],
}

units["school/sword"] = {
    "jobKey": "school/sword",
    "jobName": "Swordsman",
    "attacktype": "steel",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "items": [{
        "title": "Sword",
        "iconKey": "relic-blade",
        "description": BasicDescription,
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 1,
        "skillKeys": ["attack"],
        "weaponImageKey": "sword",
    }],
}

units["school/spear"] = {
    "jobKey": "school/spear",
    "jobName": "Spearman",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "items": [{
        "title": "Spear",
        "iconKey": "spear-hook",
        "description": BasicDescription,
        "element": "water",
        "attacktype": "steel",
        "attackrange": 1,
        "skillKeys": ["attack"],
        "weaponImageKey": "spear",
    }],
}

units["school/axe"] = {
    "jobKey": "axe",
    "jobName": "Axeman",
    "attackrange": 1,
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "items": [{
        "title": "Axe",
        "iconKey": "battered-axe",
        "description": BasicDescription,
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 1,
        "skillKeys": ["attack"],
        "weaponImageKey": "axe",
    }],
}

units["school/mage"] = {
    "jobKey": "mage",
    "jobName": "Mage",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "items": [{
        "title": "Staff",
        "iconKey": "wizard-staff",
        "description": BasicDescription,
        "element": "fire",
        "attacktype": "magic",
        "attackrange": 2,
        "skillKeys": ["attack"],
        "weaponImageKey": "red-staff"
    }],
}

units["school/priest"] = {
    "jobKey": "priest",
    "jobName": "Priest",
    // "skillKeys": ["heal"],
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "items": [{
        "title": "Staff",
        "iconKey": "wizard-staff",
        "description": BasicDescription,
        "element": "water",
        "attacktype": "magic",
        "attackrange": 2,
        "skillKeys": ["attack"],
        "weaponImageKey": "blue-staff",
    }],
}

units["school/shaman"] = {
    "jobKey": "school/shaman",
    "jobName": "Shaman",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "items": [{
        "title": "Staff",
        "iconKey": "wizard-staff",
        "description": BasicDescription,
        "element": "earth",
        "attacktype": "magic",
        "attackrange": 2,
        "skillKeys": ["attack"],
        "weaponImageKey": "green-staff",
    }],
}
